export default __webpack_public_path__ + "static/media/main_slide_Image3.f15b9a70.jpg";